/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EducationContentRequest
 */
export interface EducationContentRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationContentRequest
     */
    degree: string;
    /**
     * 
     * @type {string}
     * @memberof EducationContentRequest
     */
    school: string;
    /**
     * 
     * @type {number}
     * @memberof EducationContentRequest
     */
    graduationYear?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EducationContentRequest
     */
    current?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EducationContentRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the EducationContentRequest interface.
 */
export function instanceOfEducationContentRequest(value: object): value is EducationContentRequest {
    if (!('degree' in value) || value['degree'] === undefined) return false;
    if (!('school' in value) || value['school'] === undefined) return false;
    return true;
}

export function EducationContentRequestFromJSON(json: any): EducationContentRequest {
    return EducationContentRequestFromJSONTyped(json, false);
}

export function EducationContentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EducationContentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'degree': json['degree'],
        'school': json['school'],
        'graduationYear': json['graduationYear'] == null ? undefined : json['graduationYear'],
        'current': json['current'] == null ? undefined : json['current'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function EducationContentRequestToJSON(value?: EducationContentRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'degree': value['degree'],
        'school': value['school'],
        'graduationYear': value['graduationYear'],
        'current': value['current'],
        'description': value['description'],
    };
}

